define(["require", "exports", "jquery"], function (require, exports, $) {
    "use strict";
    exports.__esModule = true;
    function raw(s) {
        return s;
    }
    function decoded(s) {
        return decodeURIComponent(s.replace(/\+/g, ' '));
    }
    function converted(s, options) {
        if (s.indexOf('"') === 0) {
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }
        try {
            return options.json ? JSON.parse(s) : s;
        }
        catch (er) { }
    }
    function writeCookie(key, value, options) {
        var config = $.extend({}, options);
        if ($.isNumeric(config.expires)) {
            var days = config.expires;
            var t = config.expires = new Date();
            t.setDate(t.getDate() + days);
        }
        value = config.json ? JSON.stringify(value) : String(value);
        return (document.cookie = [
            config.raw ? key : encodeURIComponent(key),
            '=',
            config.raw ? value : encodeURIComponent(value),
            config.expires ? '; expires=' + config.expires.toUTCString() : '',
            config.path ? '; path=' + config.path : '',
            config.domain ? '; domain=' + config.domain : '',
            config.secure ? '; secure' : ''
        ].join(''));
    }
    function readCookie(key, options) {
        var config = $.extend({}, options);
        var decode = config.raw ? raw : decoded;
        var cookies = document.cookie.split('; ');
        var result = key ? undefined : {};
        for (var i = 0, l = cookies.length; i < l; i++) {
            var parts = cookies[i].split('=');
            var name = decode(parts.shift());
            var cookie = decode(parts.join('='));
            if (key && key === name) {
                result = converted(cookie, config);
                break;
            }
            if (!key) {
                result[name] = converted(cookie, config);
            }
        }
        return result;
    }
    function removeCookie(key, options) {
        if ($.cookie(key) !== undefined) {
            $.cookie(key, '', $.extend({}, options, { expires: -1 }));
            return true;
        }
        return false;
    }
    $.cookie = function (key, value, options) {
        if (value === undefined) {
            return readCookie(key, options);
        }
        else {
            return writeCookie(key, value, options);
        }
    };
    $.removeCookie = removeCookie;
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/jquery-plugins/jquery-cookie.js
// module id = 19
// module chunks = 0